import ApiService from '@/services/api.service';

const state = {
    payment: []
};

const getters = {
    payment: state => state.payment
}

const actions = {
    getPayment(context, payload) {
        return ApiService
            .post('payment_create/', payload)
            .then(response => {
                context.commit('setPayment', response.data.results);
            })
            .catch(error => {
                console.log(error);
            });
    }
}

const mutations = {
    setPayment(state, payload) {
        state.payment = payload;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
